module.exports = __webpack_public_path__ + "static/team.5bda192d.svg";